import { Notification } from 'element-ui'
import { portalInstanceToFullscreen } from './fullscreenPortal'

/**
 * 右上角轻提示（Element UI Notification，固定 position: top-right）。
 *
 * <p>用途：告诉用户「刚才那个操作到底成功没有」——评论发送 / 删除 / 点赞等。
 * 这些结果以前用 `alert()` 弹原生框，会阻塞页面、样式也跟全站不搭，统一换成右上角浮层。</p>
 *
 * <p>Element 是按需引入的（见 main.js），这里直接 import { Notification }，
 * 不依赖 `Vue.prototype.$notify` 的挂载时机，api / 工具模块里也能直接用。</p>
 *
 * 外观由 App.vue 全局样式里的 `.el-notification` 覆盖块统一接管（--lp-* 令牌），
 * 这里通过 customClass 只负责挂一个类名，方便以后单独微调。
 */

const DEFAULT_DURATION = 2600
const CUSTOM_CLASS = 'lp-notify'
/** 同一时刻最多挂几条，超了就先关掉最早的，避免叠成一列盖住表格 */
const MAX_VISIBLE = 3

/** @type {Array<{id:string,close:Function}>} 按弹出顺序排列的存活实例 */
const alive = []

function push(type, title, message, options) {
  const extra = options || {}
  const userOnClose = extra.onClose
  const instance = Notification(Object.assign({}, extra, {
    type,
    title: title || '',
    message: message || '',
    position: 'top-right',
    duration: DEFAULT_DURATION,
    customClass: CUSTOM_CLASS,
    onClose: () => {
      const i = alive.findIndex(item => item.instance === instance)
      if (i !== -1) alive.splice(i, 1)
      if (typeof userOnClose === 'function') userOnClose()
    }
  }))
  alive.push({ instance })
  // 全屏视图：Notification 默认挂 document.body，会被时间表全屏层（top layer）盖住，
  // 这里搬进全屏元素（非全屏时 no-op）
  portalInstanceToFullscreen(instance)
  // 注意：Notification 自己按存活实例累加 verticalOffset，这里提前 close 后
  // 它内部会自动把后面的实例往上挪，不需要我们手动重排。
  while (alive.length > MAX_VISIBLE) {
    const oldest = alive.shift()
    if (oldest && oldest.instance) {
      try { oldest.instance.close() } catch (e) { /* 已销毁则忽略 */ }
    }
  }
  return instance
}

/** 操作成功：绿勾 */
export function notifySuccess(title, message, options) {
  return push('success', title, message, options)
}

/** 操作失败：红叉 */
export function notifyError(title, message, options) {
  return push('error', title, message, options)
}
